import styled from 'styled-components';
import { pxToRem } from 'utils/stylingUtils';

const StyledLabel = styled.h3`
    font-size: ${pxToRem(32)};
    margin-top: ${pxToRem(16)};
`;

export default StyledLabel;
